import { Route, Switch } from 'react-router-dom';
import { Responsive } from 'commons/components';
import { CATALOG_ROUTES } from './catalogRoutes';
import {
  TransferListMobilePage,
  TransferListDesktopPage,
  NewTransferPage,
  DetailTransferPage,
} from './Transfers/pages';

function Transfers(): JSX.Element {
  return (
    <Switch>
      <Route path={CATALOG_ROUTES.transfers} exact>
        <Responsive
          mobile={<TransferListMobilePage />}
          desktop={<TransferListDesktopPage />}
        />
      </Route>
      <Route path={CATALOG_ROUTES.newTransfer} exact>
        <NewTransferPage />
      </Route>
      <Route path={CATALOG_ROUTES.viewTransferDetails}>
        <DetailTransferPage />
      </Route>
    </Switch>
  );
}

export default Transfers;
